@if (isEmpty()) {
<section
  class="relative font-open-sans overflow-hidden rounded-[28px] border border-border-solid bg-card shadow-[0_4px_16px_rgba(0,0,0,0.08)] p-8 lg:p-10 min-h-[280px] max-sm:rounded-2xl max-sm:p-4 max-sm:min-h-0">
  <div
    class="relative z-[2] grid grid-cols-[200px_1fr_auto] items-center gap-9 p-2 max-lg:grid-cols-1 max-lg:gap-4 max-lg:justify-items-center max-lg:text-center max-sm:p-0">
    <div class="relative h-[200px] w-[200px] max-sm:h-[140px] max-sm:w-[140px]">
      <div
        class="relative z-[2] flex h-full w-full items-end justify-center overflow-hidden rounded-full border border-border-solid bg-muted-solid">
        <svg viewBox="0 0 132 167" class="block h-[82.27%] w-[65.02%]" fill="none" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M65.3787 67C83.8802 67 98.8787 52.0015 98.8787 33.5C98.8787 14.9985 83.8802 0 65.3787 0C46.8771 0 31.8787 14.9985 31.8787 33.5C31.8787 52.0015 46.8771 67 65.3787 67ZM65.7501 85.2006C31.3472 85.2006 3.08939 110.662 -0.000244141 143.175C17.6523 158.373 40.6277 167.561 65.7491 167.561C90.8713 167.561 113.847 158.373 131.5 143.173C128.41 110.661 100.152 85.2006 65.7501 85.2006Z"
            fill="var(--muted-foreground)" />
        </svg>
      </div>
      <span
        class="pointer-events-none absolute -inset-[10px] rounded-full border-2 border-primary opacity-55 animate-pickup-scan-pulse"
        aria-hidden="true"></span>
      <span
        class="pointer-events-none absolute -inset-[10px] rounded-full border-2 border-primary opacity-30 animate-pickup-scan-pulse [animation-delay:900ms]"
        aria-hidden="true"></span>
      <span
        class="absolute bottom-1.5 right-1.5 z-[3] grid h-11 w-11 place-items-center rounded-full border-[3px] border-background bg-card text-primary shadow-[0_0_0_1px_var(--border-solid)]">
        <i class="fi fi-rr-face-viewfinder text-[18px] leading-[0]"></i>
      </span>
    </div>

    <div class="max-w-[680px] min-w-0">
      <lib-badge class="mb-3 inline-block" type="blue">
        <span class="h-2 w-2 rounded-full bg-blue-foreground animate-pickup-dot-pulse"></span>
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.STATUS.WAITING' | translate }}
      </lib-badge>
      <h2 class="m-0 mb-2.5 text-[clamp(1.75rem,2.6vw,2.25rem)] font-semibold text-foreground"
        style="text-wrap: balance">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.HERO_EMPTY_TITLE' | translate }}
      </h2>
      <p class="m-0 max-w-[560px] content-regular text-muted-foreground">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.HERO_EMPTY_DESCRIPTION' | translate }}
      </p>
    </div>
  </div>
</section>
} @else {
<section [@heroChangeAnimation]="heroId()"
  class="relative overflow-hidden rounded-[28px] border border-primary-50 bg-card shadow-[0_4px_16px_rgba(0,0,0,0.08)] p-8 lg:p-10 max-sm:rounded-2xl max-sm:p-4">
  @if (displayType() === 'arrival') {
    @for (key of [heroId() || 'arrival']; track key) {
      <div class="pointer-events-none absolute inset-0 z-[5] rounded-[28px] bg-[color-mix(in_srgb,var(--primary)_35%,transparent)] animate-hero-highlight-fade" aria-hidden="true"></div>
    }
  }

  <div
    class="relative z-[2] grid grid-cols-[auto_1fr_auto] items-center gap-9 max-lg:grid-cols-1 max-lg:gap-4 max-lg:justify-items-center max-lg:text-center">
    <div class="relative shrink-0 max-sm:[&_lib-avatar]:!h-[140px] max-sm:[&_lib-avatar]:!w-[140px]">
      @if (displayType() === 'arrival') {
        @for (key of [heroId() || 'arrival']; track key) {
          <span class="pointer-events-none absolute -inset-1.5 rounded-full border-2 border-primary opacity-0 animate-hero-recognition-ring motion-reduce:animate-none" aria-hidden="true"></span>
        }
      }
      @for (id of [personId()]; track id) {
        <lib-avatar [tooltipFollowDisabled]="true" [customSize]="200" [personId]="id" [firstName]="firstName()"
          [lastName]="lastName()" />
      }
    </div>

    <div class="min-w-0 max-lg:w-full">
      <lib-badge class="mb-4 inline-block" type="blue">
        <span class="h-2 w-2 rounded-full bg-blue-foreground animate-pickup-dot-pulse"></span>
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.NEW_ARRIVAL' | translate }}
      </lib-badge>
      <h1 class="m-0 text-[clamp(2.5rem,5vw,4.5rem)] font-extrabold leading-[0.95] text-foreground max-sm:text-3xl"
        style="text-wrap: balance">
        {{ studentName() }}
      </h1>

      <div
        class="mt-6 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-border-solid pt-6 max-sm:mt-4 max-sm:pt-4 max-sm:gap-x-4 max-sm:gap-y-3">
        <!-- TODO(live-pickup): reativar quando o backend enviar StudentClassDisplay.
        <div class="flex items-center gap-4 max-sm:gap-3">
          <div
            class="grid h-[52px] w-[52px] place-items-center rounded-2xl text-foreground-75 max-sm:h-10 max-sm:w-10 max-sm:rounded-lg">
            <i class="fi fi-rr-users text-[22px] leading-[0] max-sm:text-base"></i>
          </div>
          <div class="flex flex-col max-sm:items-start">
            <span class="content-semibold text-foreground-50">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.CLASS' | translate
              }}</span>
            <span class="text-2xl font-bold text-foreground max-sm:text-base">{{ turma() }}</span>
          </div>
        </div>
        -->

        <div class="flex items-center gap-4 max-sm:gap-3">
          <div
            class="grid h-[52px] w-[52px] place-items-center rounded-2xl text-foreground-75 max-sm:h-10 max-sm:w-10 max-sm:rounded-lg">
            <i class="fi fi-rr-user text-[22px] leading-[0] max-sm:text-base"></i>
          </div>
          <div class="flex flex-col max-sm:items-start">
            <span class="content-semibold text-foreground-50">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.GUARDIAN' | translate
              }}</span>
            <span class="text-2xl font-bold text-foreground max-sm:text-base">{{ responsavel() }}</span>
          </div>
        </div>

        <div class="flex items-center gap-4 max-sm:gap-3">
          <div
            class="grid h-[52px] w-[52px] place-items-center rounded-2xl text-foreground-75 max-sm:h-10 max-sm:w-10 max-sm:rounded-lg">
            <i class="fi fi-rr-clock text-[22px] leading-[0] max-sm:text-base"></i>
          </div>
          <div class="flex flex-col max-sm:items-start">
            <span class="content-semibold text-foreground-50">
              {{ (displayType() === 'arrival' ? 'ACCESS.CHECKIN.LIVE_PICKUP.ARRIVED_AT' :
              'ACCESS.CHECKIN.LIVE_PICKUP.RECOGNIZED_AT') | translate }}
            </span>
            <span class="text-2xl font-bold tabular-nums text-foreground max-sm:text-base">
              {{ reconhecimentoTime() | intlDateTime: { hour: '2-digit', minute: '2-digit' } }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex min-w-[280px] shrink-0 flex-col items-center gap-3 rounded-2xl border border-primary-50 bg-primary-20 px-9 py-7 text-center max-lg:w-full max-lg:min-w-0 max-lg:items-center max-lg:justify-center max-sm:gap-3 max-sm:px-4 max-sm:py-3 max-sm:rounded-xl max-sm:text-left">
      <i class="fi fi-rr-marker text-[40px] text-primary leading-none max-sm:text-2xl"></i>
      <span class="content-semibold tracking-wider text-foreground-75 max-sm:order-2">{{
        'ACCESS.CHECKIN.LIVE_PICKUP.PROCEED_TO' | translate }}</span>
      <span
        class="text-[clamp(2rem,3.5vw,2.75rem)] font-semibold leading-[1.05] tracking-tight text-foreground max-sm:order-3 max-sm:text-xl">{{
        portao() }}</span>
    </div>
  </div>
</section>
}